import { render, staticRenderFns } from "./ComparaSpecifiche.vue?vue&type=template&id=ab52ecc8"
import script from "./ComparaSpecifiche.vue?vue&type=script&lang=js"
export * from "./ComparaSpecifiche.vue?vue&type=script&lang=js"
import style0 from "./ComparaSpecifiche.vue?vue&type=style&index=0&id=ab52ecc8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports